export const copyContent = async (text = '') => {
  try {
    await navigator.clipboard.writeText(text);
    /* Resolved - text copied to clipboard successfully */
  } catch (err) {
    /* Rejected - text failed to copy to the clipboard */
  }
};
